import React, {useEffect, useState} from 'react';
import {Box, Container, makeStyles, Typography} from '@material-ui/core';
import usePage from '@/hooks/usePage.js';
import Request from '@/helpers/request.js';
import mainStyles from '@/assets/js/mainStyles.js';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/zoom/lib/styles/index.css';
import ReactPlayer from "react-player";

const useStyles = makeStyles(mainStyles);

const Implementation = () => {
  const classes = useStyles();
  const [regulation, setRegulation] = useState(null);
  const {setTitle} = usePage();

  useEffect(async () => {
    const fetchModule = async () => {
      const response = (await Request.get(`/p3d2-regulation`)).items[0];
      setRegulation(response);
      setTitle('Vérification de mise en place');
    };
    await fetchModule();
  }, []);

  return (
    <Container maxWidth="md">
      <Box className={classes.descRoot}>
        {regulation && (
          <Box className={classes.videoBox} style={{height: '500px'}}>
            <Typography variant="h5" className={classes.description}>Une vidéo motion design</Typography>
            <ReactPlayer url={regulation?.configurators} width="100%" height="100%" controls/>
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default Implementation;
